import { Stack, Typography } from '@mui/material'

import { riskColor } from '@/theme/chartColors'
import { RISK_LEVEL_LABEL } from '@/utils/statusLabels'

/**
 * Nivel de riesgo/atención — REUTILIZA `riskColor()`
 * (`theme/chartColors.ts`) y `RISK_LEVEL_LABEL` (`utils/statusLabels.ts`),
 * ya usados en todo GOVIA (mapa territorial, ExecutivePriority, RiskLevelChart)
 * — cero lógica de color nueva, cero traducción duplicada.
 */
export function SeverityIndicator({ level, dense = false }: { level: string; dense?: boolean }) {
  const normalized = level?.toLowerCase() ?? 'none'
  return (
    <Stack direction="row" alignItems="center" spacing={0.75}>
      <Stack
        sx={{
          width: dense ? 8 : 10,
          height: dense ? 8 : 10,
          borderRadius: '50%',
          bgcolor: riskColor(normalized),
          boxShadow: dense ? 'none' : `0 0 12px ${riskColor(normalized)}66`,
          flexShrink: 0,
        }}
      />
      <Typography variant={dense ? 'caption' : 'body2'} sx={{ fontWeight: 600 }}>
        {RISK_LEVEL_LABEL[normalized] ?? level}
      </Typography>
    </Stack>
  )
}
